import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Table,
  Button,
  Badge
} from 'reactstrap';
import { fetchStaffRequests } from './actions/action';

const StaffRequestsOffcanvas = ({ isOpen, toggle, onViewDetails, onCreateTO }) => {
  const dispatch = useDispatch();
  const [requests, setRequests] = useState([]);
  useEffect(() => {
    const loadRequests = async () => {
      try {
        const res = await fetchStaffRequests({ dispatch });
        if (res && Array.isArray(res)) {
          // Group by technician_id and created_at date (YYYY-MM-DD)
          const grouped = res.reduce((acc, current) => {
            const dateStr = current.created_at ? current.created_at.substring(0, 10) : 'N/A'; // YYYY-MM-DD
            const key = `${current.technician_id}-${dateStr}`;
            
            if (!acc[key]) {
              acc[key] = {
                staff_id: current.technician_id,
                technicianId: current.technician_id,
                assign_staff_id: current.technician_id,
                staff_name: current.technician_name,
                qty: 0,
                created_date: dateStr,
                created_by_name: current.created_by_name,
                items: []
              };
            }
            acc[key].qty += Number(current.requested_qty || 0);
            acc[key].items.push(current);
            return acc;
          }, {});
          
          setRequests(Object.values(grouped));
        } else {
          setRequests([]);
        }
      } catch (error) {
        console.error("Failed to fetch staff requests:", error);
        setRequests([]);
      }
    };

    if (isOpen) {
      loadRequests();
    }
  }, [isOpen]);


  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="end"
      style={{ width: '800px' }}
    >
      <OffcanvasHeader toggle={toggle}>
        Staff Requests List
      </OffcanvasHeader>
      <OffcanvasBody>
        <div className="table-responsive">
          <Table hover>
            <thead>
              <tr>
                <th>Staff ID</th>
                <th>Staff Name</th>
                <th>Qty</th>
                <th>Created by</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((request, index) => (
                <tr key={index}>
                  <td>{request.staff_id}</td>
                  <td className='text-capitalize'>{request.staff_name}</td>
                  <td>
                    <Badge color="info">{request.qty}</Badge>
                  </td>
                  <td className='text-capitalize'>
                    {request.created_by_name}
                    <br/>
                    {request.created_date}
                  </td>
                  <td>
                    <div className="d-flex gap-2">
                      <Button
                        color="secondary"
                        size="sm"
                        onClick={() => onViewDetails(request)}
                      >
                        <i className="fa fa-eye"></i> View
                      </Button>
                      <Button
                        color="success"
                        size="sm"
                        onClick={() => onCreateTO(request)}
                      >
                        <i className="fa fa-plus"></i> Create
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
              {requests.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center">No requests found</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default StaffRequestsOffcanvas;
